import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=140ea015&scoped=true&"
import script from "./UserTransactions.vue?vue&type=script&lang=js&"
export * from "./UserTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ea015",
  null
  
)

export default component.exports